module.exports = "graphic-structure"